"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _mobxUtils = require("mobx-utils");
var _map2 = _interopRequireDefault(require("lodash/map"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _adSolutionClient = require("../clients/ad-solution.client.js");
var _index = require("../utils/store.utils/index.js");
var _adSolutionUtils = require("../utils/ad-solution.utils.js");
var _index2 = require("../constants/index.js");
var _adSolutionConstants = require("../constants/ad-solution.constants.js");
var _adBannerFactory = require("../factories/ad-banner.factory.js");
var _adPromotionFactory = require("../factories/ad-promotion.factory.js");
var _adCarouselFactory = require("../factories/ad-carousel.factory.js");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
var INITIAL = _index2.API_STATE.INITIAL,
  LOADING = _index2.API_STATE.LOADING,
  SUCCESS = _index2.API_STATE.SUCCESS,
  FAILED = _index2.API_STATE.FAILED;
var ACTION_TYPES = {
  FETCH_ADS: 'FETCH_ADS',
  SEND_INTERACTION: 'SEND_INTERACTION'
};
var AdSolutionStore = exports["default"] = (_dec = _mobx.observable.shallow, _dec2 = _mobx.observable.shallow, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, (_class = /*#__PURE__*/function () {
  function AdSolutionStore(initialState, $env, baseURL) {
    var _this = this;
    if (initialState === void 0) {
      initialState = {};
    }
    if ($env === void 0) {
      $env = {};
    }
    if (baseURL === void 0) {
      baseURL = '';
    }
    this.$env = void 0;
    this.baseURL = void 0;
    (0, _initializerDefineProperty2["default"])(this, "adPlacementData", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "sentAds", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "API_STATE", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "isLocal", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "appliedBanner", _descriptor5, this);
    (0, _initializerDefineProperty2["default"])(this, "invalidBanners", _descriptor6, this);
    this.isLoading = (0, _mobxUtils.computedFn)(function (actionType) {
      return _this.API_STATE[actionType] === LOADING;
    }, true);
    this.isFetched = (0, _mobxUtils.computedFn)(function (actionType) {
      return _this.API_STATE[actionType] === SUCCESS;
    }, true);
    this.hasError = (0, _mobxUtils.computedFn)(function (actionType) {
      return _this.API_STATE[actionType] === FAILED;
    }, true);
    this.promotedResults = (0, _mobxUtils.computedFn)(function (searchResults, config) {
      return (0, _adSolutionUtils.promoteResults)(searchResults, _this.adPromotions, config);
    });
    this.requestURL = (0, _mobxUtils.computedFn)(function (resultId, interaction) {
      var _this$adPlacementMap, _this$adPlacementMap$, _this$adPlacementMap2, _this$adPlacementMap3, _this$adPlacementMap4, _this$adPlacementMap5;
      if (interaction === _adSolutionConstants.AD_INTERACTION.ELIGIBLE) return (_this$adPlacementMap = _this.adPlacementMap) === null || _this$adPlacementMap === void 0 ? void 0 : (_this$adPlacementMap$ = _this$adPlacementMap[resultId]) === null || _this$adPlacementMap$ === void 0 ? void 0 : _this$adPlacementMap$.eligibleURL;
      if (interaction === _adSolutionConstants.AD_INTERACTION.VIEWABLE) return (_this$adPlacementMap2 = _this.adPlacementMap) === null || _this$adPlacementMap2 === void 0 ? void 0 : (_this$adPlacementMap3 = _this$adPlacementMap2[resultId]) === null || _this$adPlacementMap3 === void 0 ? void 0 : _this$adPlacementMap3.viewableURL;
      if (interaction === _adSolutionConstants.AD_INTERACTION.REDIRECT) return (_this$adPlacementMap4 = _this.adPlacementMap) === null || _this$adPlacementMap4 === void 0 ? void 0 : (_this$adPlacementMap5 = _this$adPlacementMap4[resultId]) === null || _this$adPlacementMap5 === void 0 ? void 0 : _this$adPlacementMap5.redirectURL;
    });
    this.shouldSendAd = (0, _mobxUtils.computedFn)(function (resultId, interaction) {
      var isNotIncluded = Array.isArray(_this.sentAds[interaction]) && !_this.sentAds[interaction].includes(resultId);
      return isNotIncluded && _this.requestURL(resultId, interaction);
    });
    (0, _initializerDefineProperty2["default"])(this, "fetchAdPlacements", _descriptor7, this);
    (0, _initializerDefineProperty2["default"])(this, "sendInteraction", _descriptor8, this);
    this.$env = $env;
    this.baseURL = baseURL;
    this.updateInitialState(initialState);
    this.resetSentAds();
  }
  var _proto = AdSolutionStore.prototype;
  _proto.addToSentAds = function addToSentAds(resultId, interaction) {
    if (Array.isArray(this.sentAds[interaction])) {
      this.sentAds[interaction].push(resultId);
    }
  };
  _proto.setAppliedBanner = function setAppliedBanner(zoneId) {
    this.appliedBanner = zoneId;
  };
  _proto.resetAppliedBanner = function resetAppliedBanner() {
    this.appliedBanner = '';
  };
  _proto.addInvalidBanner = function addInvalidBanner(zoneId) {
    this.invalidBanners.push(zoneId);
  };
  _proto.resetInvalidBanners = function resetInvalidBanners() {
    this.invalidBanners = [];
  };
  _proto.onSuccess = function onSuccess(actionType) {
    this.API_STATE[actionType] = SUCCESS;
  };
  _proto.onError = function onError(error, errorHandler, actionType) {
    var _error$response$data, _error$response;
    this.API_STATE[actionType] = FAILED;
    var errorResponse = (_error$response$data = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) !== null && _error$response$data !== void 0 ? _error$response$data : error.response;
    errorHandler(errorResponse || error);
  };
  _proto.setIsLocal = function setIsLocal(isLocal) {
    this.isLocal = isLocal;
  };
  _proto.resetSentAds = function resetSentAds() {
    var _this$sentAds;
    this.sentAds = (_this$sentAds = {}, _this$sentAds[_adSolutionConstants.AD_INTERACTION.ELIGIBLE] = [], _this$sentAds[_adSolutionConstants.AD_INTERACTION.VIEWABLE] = [], _this$sentAds[_adSolutionConstants.AD_INTERACTION.REDIRECT] = [], _this$sentAds);
  };
  _proto.resetState = function resetState() {
    var _this$API_STATE;
    this.resetSentAds();
    this.adPlacementData = {};
    this.API_STATE = (_this$API_STATE = {}, _this$API_STATE[ACTION_TYPES.FETCH_ADS] = INITIAL, _this$API_STATE[ACTION_TYPES.SEND_INTERACTION] = INITIAL, _this$API_STATE);
  };
  _proto.updateInitialState = function updateInitialState(initialState) {
    (0, _index.mapInitialStateToStoreState)(this, initialState);
  };
  (0, _createClass2["default"])(AdSolutionStore, [{
    key: "isAdPlacementsFetched",
    get: function get() {
      return this.isFetched(ACTION_TYPES.FETCH_ADS);
    }
  }, {
    key: "adBanners",
    get: function get() {
      return (0, _filter2["default"])(this.adPlacements, function (adPlacement) {
        var _adPlacement$template;
        return (adPlacement === null || adPlacement === void 0 ? void 0 : (_adPlacement$template = adPlacement.template_params) === null || _adPlacement$template === void 0 ? void 0 : _adPlacement$template.type) === _adSolutionConstants.AD_TYPE.BANNER;
      });
    }
  }, {
    key: "adCarouselItems",
    get: function get() {
      return (0, _filter2["default"])(this.adPlacements, function (adPlacement) {
        var _adPlacement$template2;
        return (adPlacement === null || adPlacement === void 0 ? void 0 : (_adPlacement$template2 = adPlacement.template_params) === null || _adPlacement$template2 === void 0 ? void 0 : _adPlacement$template2.type) === _adSolutionConstants.AD_TYPE.CAROUSEL;
      });
    }
  }, {
    key: "availableAdBanners",
    get: function get() {
      var _this2 = this;
      return this.adBanners.filter(function (adBanner) {
        return adBanner.zoneId !== _this2.appliedBanner && !_this2.invalidBanners.includes(adBanner.zoneId);
      });
    }
  }, {
    key: "adBannerMap",
    get: function get() {
      return (0, _keyBy2["default"])(this.availableAdBanners, 'position');
    }
  }, {
    key: "adPromotions",
    get: function get() {
      return (0, _filter2["default"])(this.adPlacements, function (adPlacement) {
        var _adPlacement$template3;
        return (adPlacement === null || adPlacement === void 0 ? void 0 : (_adPlacement$template3 = adPlacement.template_params) === null || _adPlacement$template3 === void 0 ? void 0 : _adPlacement$template3.type) === _adSolutionConstants.AD_TYPE.LISTING;
      });
    }
  }, {
    key: "adPlacements",
    get: function get() {
      var _this3 = this;
      return (0, _flatMap2["default"])(this.adPlacementData, function (_ref, zoneId) {
        var placements = _ref.placements;
        return (0, _map2["default"])(placements, function (placement) {
          switch (placement.template_params.type) {
            case _adSolutionConstants.AD_TYPE.LISTING:
              return (0, _adPromotionFactory.adPromotionFactory)(placement, zoneId, _this3.baseURL);
            case _adSolutionConstants.AD_TYPE.BANNER:
              return (0, _adBannerFactory.adBannerFactory)(placement, zoneId, _this3.baseURL, _this3.$env.config.language);
            case _adSolutionConstants.AD_TYPE.CAROUSEL:
              return (0, _adCarouselFactory.adCarouselFactory)(placement, zoneId, _this3.baseURL, _this3.$env.config.language);
          }
        });
      });
    }
  }, {
    key: "adPlacementMap",
    get: function get() {
      return (0, _keyBy2["default"])(this.adPlacements, 'zoneId');
    }
  }, {
    key: "env",
    get: function get() {
      return this.isLocal ? _index2.ENV.LOCAL : this.$env.config.env;
    }
  }]);
  return AdSolutionStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "adPlacementData", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "sentAds", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _ref2;
    return _ref2 = {}, _ref2[ACTION_TYPES.FETCH_ADS] = INITIAL, _ref2[ACTION_TYPES.SEND_INTERACTION] = INITIAL, _ref2;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isLocal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "appliedBanner", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "invalidBanners", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "isAdPlacementsFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAdPlacementsFetched"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "adBanners", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adBanners"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "adCarouselItems", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adCarouselItems"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "availableAdBanners", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableAdBanners"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "adBannerMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adBannerMap"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "adPromotions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adPromotions"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "adPlacements", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adPlacements"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "adPlacementMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adPlacementMap"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "env", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "env"), _class.prototype), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "fetchAdPlacements", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _index.flow)(function fetchAdPlacements(payload, errorHandler) {
      var _this4 = this;
      if (errorHandler === void 0) {
        errorHandler = function errorHandler() {
          return null;
        };
      }
      return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.API_STATE[ACTION_TYPES.FETCH_ADS] = LOADING;
              _context.prev = 1;
              _context.next = 4;
              return _adSolutionClient.AdSolutionClient.fetchAdPlacements(payload, _this4.baseURL, _this4.env);
            case 4:
              _this4.adPlacementData = _context.sent;
              _this4.resetSentAds();
              _this4.resetAppliedBanner();
              _this4.resetInvalidBanners();
              _this4.onSuccess(ACTION_TYPES.FETCH_ADS);
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              _this4.onError(_context.t0, errorHandler, ACTION_TYPES.FETCH_ADS);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 11]]);
      })();
    });
  }
}), _descriptor8 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "sendInteraction", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _index.flow)(function sendInteraction(resultId, interaction, errorHandler) {
      var _this5 = this;
      if (errorHandler === void 0) {
        errorHandler = function errorHandler() {
          return null;
        };
      }
      return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var requestURL;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this5.shouldSendAd(resultId, interaction)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this5.API_STATE[ACTION_TYPES.SEND_INTERACTION] = LOADING;
              _context2.prev = 3;
              requestURL = _this5.requestURL(resultId, interaction);
              _context2.next = 7;
              return _adSolutionClient.AdSolutionClient.sendInteraction(requestURL);
            case 7:
              interaction !== _adSolutionConstants.AD_INTERACTION.REDIRECT && _this5.addToSentAds(resultId, interaction);
              _this5.onSuccess(ACTION_TYPES.SEND_INTERACTION);
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              _this5.onError(_context2.t0, errorHandler, ACTION_TYPES.SEND_INTERACTION);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 11]]);
      })();
    });
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "addToSentAds", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "addToSentAds"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setAppliedBanner", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "setAppliedBanner"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "resetAppliedBanner", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "resetAppliedBanner"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "addInvalidBanner", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "addInvalidBanner"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "resetInvalidBanners", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "resetInvalidBanners"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setIsLocal", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsLocal"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "resetSentAds", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetSentAds"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "resetState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetState"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype)), _class));